import PageHeader from "components/PageHeader";
import useCreativeJobsQuery from "api/hooks/useCreativeJobsQuery";
import { extractApiErrorMessage } from "utils/util";
import DSStack from "views/system-design/DSStack";
import CreativeJobForm from "./CreativeJobForm";
import CreativeJobsTable from "./CreativeJobsTable";

/**
 * Creative Studio: describe an image, a video or a klydo animation, and an AI
 * pipeline (Claude + Remotion) makes it in the background.
 */
const CreativeStudio = () => {
  const jobs = useCreativeJobsQuery();

  return (
    <>
      <PageHeader
        overline="Content"
        title="Creative Studio"
        subtitle="Describe an image, a video or a klydo animation, and Claude AI makes it for you."
      />
      <DSStack spacing={3}>
        <CreativeJobForm jobs={jobs.data ?? []} />
        <CreativeJobsTable
          jobs={jobs.data ?? []}
          isLoading={jobs.isLoading}
          errorMessage={
            jobs.isError && !jobs.data
              ? extractApiErrorMessage(jobs.error, "Could not load the jobs")
              : undefined
          }
        />
      </DSStack>
    </>
  );
};

export default CreativeStudio;
